/* src/app/quoting/pages/quote-decline/quote-decline.component.scss */
/*# sourceMappingURL=quote-decline.component.css.map */
